<template>
  <div id="crm-coupon-page">
    <main-header
      :title="title"
      iconRightBtn="history.png"
      isIconRightBtnFromFile
      @onClickRightBtn="onClickRightBtn"
    >
      <CouponList />
    </main-header>
    <main-footer />
  </div>
</template>

<script>
import CouponList from "@components/coupon/CouponList";
import MainFooter from "@components/MainFooter";
import MainHeader from "@components/MainHeader";
import GATracking from "@/helper/GATrackingMixins";

export default {
  components: {
    CouponList,
    MainFooter,
    MainHeader,
  },
  mixins: [GATracking],
  data() {
    return {
      title: this.$t('coupon.coupon-mine'),
    };
  },
  methods: {
    onClickRightBtn() {
      this.trackReward(4, 'CRMPointHistory');
      this.$router.push({ name: 'History' });
    },
  },
  mounted() {
    this.viewReward()
  },
};
</script>